import { useAppSelector } from "Components/Hooks/hooks";
import Icon from "Components/Icons/Icon";
import React from "react";
import {
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  UncontrolledDropdown,
} from "reactstrap";

interface ActionMenuProps {
  onView?: () => void;
  onEdit?: () => void;
  onDelete?: () => void;
  isView?: boolean;
  isEdit?: boolean;
  isDelete?: boolean;
  isImpersonate?: boolean;
  onImpersonate?: () => void;
  isShare?: boolean;
  onShare?: () => void;
}

const ActionMenu = ({
  onView,
  onEdit,
  onDelete,
  isView,
  isEdit = true,
  isDelete = true,
  isImpersonate,
  onImpersonate,
  isShare,
  onShare,
}: ActionMenuProps) => {
  const { user } = useAppSelector((state) => state.auth);
  const role = user?.role;
  return role === "user" ? (
    <div className="d-flex gap-2">
      {isView && (
        <Icon
          name="PrimaryView"
          className="btn-press-effect me-1 cursor-pointer"
          onClick={onView}
        />
      )}
      {isEdit && (
        <Icon
          name="PrimaryEdit"
          className="btn-press-effect me-1 cursor-pointer"
          onClick={onEdit}
        />
      )}
      {isDelete && (
        <Icon
          name="PrimaryDelete"
          className="btn-press-effect me-1 cursor-pointer"
          onClick={onDelete}
        />
      )}
      {isShare && (
        <Icon
          name="PrimaryShare"
          className="btn-press-effect me-1 cursor-pointer"
          onClick={onShare}
        />
      )}
    </div>
  ) : (
    <ul className="list-inline hstack gap-2 mb-0  ">
      <li className="list-inline-item">
        <UncontrolledDropdown>
          <DropdownToggle
            className="btn btn-soft-secondary btn-sm dropdown"
            tag="button"
          >
            <i className="ri-more-fill align-middle"></i>
          </DropdownToggle>

          <DropdownMenu className="dropdown-menu-end" container="body">
            {isView && (
              <DropdownItem className="dropdown-item" onClick={onView}>
                <Icon name="View" />
                <span className="align-middle ms-2 fs-14 text-black2D fw-normal">
                  View Detail
                </span>
              </DropdownItem>
            )}

            {isShare && (
              <DropdownItem className="dropdown-item" onClick={onShare}>
                <Icon name="Share" />
                <span className="align-middle ms-2 fs-14 text-black2D fw-normal">
                  Share
                </span>
              </DropdownItem>
            )}
            {isImpersonate && (
              <DropdownItem className="dropdown-item" onClick={onImpersonate}>
                <Icon name="SearchBold" />

                <span className="align-middle ms-2 fs-14 text-black2D fw-normal">
                  Impersonate
                </span>
              </DropdownItem>
            )}

            {isDelete && (
              <DropdownItem className="dropdown-item" onClick={onDelete}>
                <Icon name="Delete" />
                <span className="align-middle ms-2 fs-14 text-black2D fw-normal">
                  Remove
                </span>
              </DropdownItem>
            )}
          </DropdownMenu>
        </UncontrolledDropdown>
      </li>
    </ul>
  );
};

export default React.memo(ActionMenu);
